import { ROUTES } from "../../../config/routes";

/** Query parameter the map reads to open the trap editor on arrival. */
export const EDIT_TRAP_PARAM = "editTrap";

/**
 * Where to send someone who asked to edit a trap from a table.
 *
 * The editor lives on the map, and the tables that offer "Edit Trap" are not
 * always on a page that has one - so the request travels as a query parameter
 * and the map picks it up when it mounts. A URL rather than shared state so
 * the action survives the navigation, and so the link can be opened directly.
 */
export const editTrapPath = (deviceUuid: string): string =>
  `${ROUTES.home}?${EDIT_TRAP_PARAM}=${encodeURIComponent(deviceUuid)}`;
